import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { socket } from "../../App";
import Rectangle1 from "../../assets/images/Rectangle 502.png";
import Rectangle2 from "../../assets/images/Rectangle 503.png";
import HeartFilled from "../../assets/svg/HeartFilled.svg";
import HeartUnfilled from "../../assets/svg/HeartUnfilled.svg";
import VectorGraph from "../../assets/svg/VectorGraph.svg";
import comment from "../../assets/svg/comment.svg";
import share from "../../assets/svg/share.svg";
import axios from "../../components/Hooks/axios";
import { setCookies } from "../../components/Hooks/setCookies";
import CommentContainer from "./CommentContainer";
import Poll from "./Poll";
import styles from "./index.module.scss";
import threeeDotsIcon from "../../assets/svg/threedots3.svg";
import { setPostReload, setShareData } from "../../redux/slices/tempSlice";
import Avatar from "../../components/Avatar/Avatar";
import ParsedText from "../../components/utilis/ParsedText";

const PostVideoContainer = ({ data }) => {
	const { userId, user, token } = useSelector((state) => state.auth);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [postData, setPostData] = useState(data);
	const [showComment, setShowComment] = useState(false);
	const [rightClick, setRightClick] = useState(false);
	const [likeCount, setLikeCount] = useState(postData?.LikeCount);
	const [isLiked, setIsLiked] = useState(postData?.isLike);
	const [pollShow, setPollShow] = useState(false);

	const [commentsData, setCommentsData] = useState(data?.Comments);

	const handelLike = () => {
		let sd = {
			notification_from: userId,
			notification_to: data.userId._id,
			notification: {},
			title: "Like",
			message: `${user.username} like your post`,
		};

		axios
			.post(`/post/${data?._id}/likeANDunlike`, {
				userId,
			})
			.then(({ data }) => {
				setIsLiked(data.totalLikes[0].isLike);
				setLikeCount(data.totalLikes[0].LikeCount);

				if (data.totalLikes[0].isLike) socket.emit("notification", sd);
			})
			.catch(({ response }) => {
				console.log(response);
			});
	};

	const handelDelete = () => {
		axios
			.delete(`/post/delete?postId=${data._id}`)
			.then(({ data }) => {
				toast.success(data.message);
				console.log(data);
				dispatch(setPostReload(true));
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const checkPrivacy = (privacy) => {
		if (!privacy) return true;
		if (postData?.userId?._id === userId) return true;
		
		const { option, specific_users = [] } = privacy;
		const isFollowing = postData?.isFollowing || false;

		if (option === 'everyone') return true;
		if (option === 'followers') return isFollowing;
		if (option === 'followers_except') {
			const isExcluded = specific_users.some(id => (id._id || id) === userId);
			return isFollowing && !isExcluded;
		}
		if (option === 'no_one_except') {
			const isIncluded = specific_users.some(id => (id._id || id) === userId);
			return isIncluded;
		}
		return false;
	};

	const handelDownload = (name) => {
		// axios({
		// 	url: postData?.mediaUrl,
		// 	method: "GET",
		// 	responseType: "blob",
		// }).then((response) => {
		// 	const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement("a");
		const media = Array.isArray(postData?.mediaUrl) ? postData.mediaUrl[0] : postData?.mediaUrl;
		link.href = typeof media === 'string' ? media : media?.url;
		link.setAttribute("download", `${name}.jpg`);
		document.body.appendChild(link);
		link.click();
		link.parentNode.removeChild(link);
		setRightClick(false)
		// });
	};

	return (
		<div
			className={styles.imageContainer}
			onContextMenu={(e) => {
				e.preventDefault();
				setRightClick(true);
			}}>
			<video
				src={(() => {
					const media = postData?.mediaUrl;
					if (!media) return "";
					if (typeof media === 'string') return media;
					if (Array.isArray(media)) {
						const first = media[0];
						if (typeof first === 'string') return first;
						return first?.url || "";
					}
					if (typeof media === 'object') return media.url || "";
					return "";
				})()}
				className={styles.MediaImage}
				onClick={() => navigate(`/Post/${postData._id}`)}
			></video>

			<div className={styles.postHeader}>
				<div
					className={styles.rightPostHeader}
					onClick={() => {
						setCookies({
							// url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}/${postData?.userId?.personalTemplate}`,
							url: `${process.env.REACT_APP_TEMPLATE_BASE_URL}`,
							token,
							personaUserId: postData?.userId._id,
							currentUserId: userId,
						});
					}}>
					<div className={styles.imagePostBox}>
						<Avatar src={postData?.userId?.ProfilePic} name={postData?.userId?.username} />
					</div>

					<div className={styles.textPostBox}>
						<h3>{postData?.userId?.username || "user"}</h3>
					</div>
				</div>

				<div className={styles.leftPostHeader}>
					{userId !== postData?.userId?._id && !postData?.isFollowing && (
                        <button 
                            className={styles.followBtn}
                            onClick={(e) => {
                                e.stopPropagation();
                                axios.post("/auth/follow", { following: postData?.userId?._id })
                                    .then(({ data }) => {
                                        toast.success(`You are now following ${postData?.userId?.username}`);
                                        setPostData(prev => ({ ...prev, isFollowing: true }));
                                    })
                                    .catch(e => console.log(e));
                            }}
                        >
                            Follow
                        </button>
                    )}
					{postData?.Enabledpoll && <img src={VectorGraph} alt="VectorGraph" onClick={(e) => { e.stopPropagation(); setPollShow(true); }} />}
					<div
                        className={styles.ThreeDots}
                        onClick={() => {
                            setRightClick(true);
                        }}
                    >
                        <img src={threeeDotsIcon} alt="Three Dots Icon" />
                    </div>
				</div>
			</div>

			<div className={styles.postFooter}>
				<div className={styles.commentContainer}>
					<ParsedText 
						className={styles.comment} 
						text={`${postData?.caption || ""} ${
							postData?.tags 
								? (Array.isArray(postData.tags) 
									? postData.tags 
									: (typeof postData.tags === 'string' && postData.tags.startsWith('[') 
										? JSON.parse(postData.tags) 
										: []))
									.map(t => `#${t}`).join(" ") 
								: ""
						}`} 
					/>
				</div>

				<div className={styles.actionContainer}>
					{checkPrivacy(postData?.privacy?.like_view) && (
						<div className={styles.h} onClick={handelLike}>
							{isLiked ? <img src={HeartFilled} alt="" /> : <img src={HeartUnfilled} alt="" />}
							<p>{likeCount}</p>
						</div>
					)}

					{checkPrivacy(postData?.privacy?.comments) && (
						<div className={styles.c} onClick={() => {
							if (!userId) return toast.info("Please login to see comments");
							setShowComment(true);
						}}>
							<img src={comment} alt="" />
							<p>{commentsData?.length}</p>
						</div>
					)}

					{checkPrivacy(postData?.privacy?.sharing) && (
						<div
							className={styles.s}
							onClick={() => dispatch(setShareData({ show: true, endPoint: "/Post/", id: postData._id }))}>
							<img src={share} alt="" />
						</div>
					)}
				</div>

				{postData?.mediaUrl?.length > 1 && (
					<div className={styles.multi}>
						<img src={Rectangle1} alt="Rectangle1" />
						<img src={Rectangle2} alt="Rectangle2" className={styles.img2} />
						{postData?.mediaUrl?.length} +
					</div>
				)}
			</div>

			{showComment && (
				<CommentContainer
					setShow={setShowComment}
					commentsData={commentsData}
					setCommentsData={setCommentsData}
					postId={postData._id}
					data={data}
				/>
			)}

			{pollShow && <Poll setPollShow={setPollShow} postData={postData} />}

			{rightClick && (
				<div
					className={styles.Popup}
					onContextMenu={(e) => {
						e.preventDefault();
						setRightClick(false);
					}}
					onClick={() => setRightClick(false)}>
					<div className={styles.btnContainer} onClick={(e) => e.stopPropagation()}>
						<button onClick={() => navigate(`/Post/${data._id}`)}>View Post</button>
						{userId === data.userId._id && <button onClick={handelDelete}>Delete Post</button>}
						{userId === data.userId._id && <button onClick={() => navigate("/PersonalInsights")}>View Stats</button>}
						<button onClick={() => handelDownload(data?.userId?.username)}>Download</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default PostVideoContainer;


